import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  //   patient: null,
  patientAppointments: [],
  AppointmentDetails: null,
};
export const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setPatientAppointments: (state, action) => {
      state.patientAppointments = action.payload || [];
    },
    setAppointmentDetails: (state, action) => {
      state.AppointmentDetails = action.payload || [];
    },
  },
});
export const { setPatientAppointments, setAppointmentDetails } =
  patientSlice.actions;
export default patientSlice.reducer;
